import { render, staticRenderFns } from "./recommendAlbum.vue?vue&type=template&id=583a9d8c&scoped=true"
import script from "./recommendAlbum.vue?vue&type=script&lang=js"
export * from "./recommendAlbum.vue?vue&type=script&lang=js"
import style0 from "./recommendAlbum.vue?vue&type=style&index=0&id=583a9d8c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583a9d8c",
  null
  
)

export default component.exports